export default "__VITE_ASSET__G2HyIpdk__"